import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { LogOut, LayoutDashboard, Shield, Handshake } from "lucide-react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 glass" data-testid="navbar">
      <nav className="max-w-7xl mx-auto px-6 h-28 flex items-center justify-between">
        <Link to="/" data-testid="nav-home-link">
          <Logo size="md" />
        </Link>
        <div className="flex items-center gap-3">
          {user && typeof user === "object" ? (
            <>
              {user.role === "admin" ? (
                <Button asChild variant="ghost" className="text-[var(--ir-text)] hover:text-[var(--ir-orange)] hover:bg-[var(--ir-surface2)]" data-testid="nav-admin-link">
                  <Link to="/admin"><Shield className="w-4 h-4 mr-2" />Admin</Link>
                </Button>
              ) : (
                <Button asChild variant="ghost" className="text-[var(--ir-text)] hover:text-[var(--ir-orange)] hover:bg-[var(--ir-surface2)]" data-testid="nav-dashboard-link">
                  <Link to="/dashboard"><LayoutDashboard className="w-4 h-4 mr-2" />My Club</Link>
                </Button>
              )}
              <Button onClick={handleLogout} variant="outline" className="border-[var(--ir-border)] bg-transparent text-[var(--ir-text)] hover:bg-[var(--ir-surface2)] rounded-none" data-testid="nav-logout-btn">
                <LogOut className="w-4 h-4 mr-2" />Sign out
              </Button>
            </>
          ) : (
            <>
              <Button asChild variant="ghost" className="hidden sm:inline-flex text-[var(--ir-text)] hover:text-[var(--ir-orange)] hover:bg-[var(--ir-surface2)]" data-testid="nav-affiliates-link">
                <Link to="/"><Handshake className="w-4 h-4 mr-2" />Affiliates</Link>
              </Button>
              <Button asChild variant="ghost" className="text-[var(--ir-text)] hover:text-[var(--ir-orange)] hover:bg-[var(--ir-surface2)]" data-testid="nav-login-link">
                <Link to="/login">Member Login</Link>
              </Button>
              <Button asChild className="bg-[var(--ir-orange)] hover:bg-[var(--ir-orange-soft)] text-white font-semibold rounded-none px-6" data-testid="nav-join-link">
                <Link to="/register">Request Access</Link>
              </Button>
            </>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
